import React from 'react';

import styled from 'styled-components';

import { ISanityLocaleBlockContent } from '@rbi-ctg/menu';
import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';
import { useStoreContext } from 'state/store';

import { Disclaimer, DisclaimerPlain } from './disclaimer';

const BoxDisclaimers = styled.div`
  padding: 0 1rem;
  margin: 1rem 0;
`;

const DisclaimerPlainLeft = styled(DisclaimerPlain)`
  text-align: start;
`;

interface ILegalDisclaimers {
  hideNutritionLegalDisclaimer?: boolean;
  legalInformation?: ISanityLocaleBlockContent;
}

export const LegalDisclaimers = ({
  hideNutritionLegalDisclaimer = false,
  legalInformation,
}: ILegalDisclaimers) => {
  const { noStoreSelected } = useStoreContext();
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { superUpsell, calorie, itemAvailability } = featureDisclaimers || {};

  return (
    <BoxDisclaimers tabIndex={0} role="note">
      {noStoreSelected && <DisclaimerPlainLeft>{itemAvailability?.locale}</DisclaimerPlainLeft>}
      {legalInformation?.localeRaw && <Disclaimer content={legalInformation.localeRaw} />}
      {!hideNutritionLegalDisclaimer && (
        <div data-testid="wizard-nutrition-disclaimer">
          <Disclaimer content={superUpsell?.localeRaw} />
          <Disclaimer content={calorie?.localeRaw} />
        </div>
      )}
    </BoxDisclaimers>
  );
};
